// 光年切片工作室 · 作品与素材索引。
import studioLogo from '../../../assets/logo.png';
import studioRvHero from '../../../docs/studio/rv_hero.png';
import studioRvCover from '../../../docs/studio/rv_cover.png';

const studioImageMap: Record<string, string> = {
  logo: studioLogo,
  rv_hero: studioRvHero,
  rv_cover: studioRvCover,
};

export function getStudioImage(key: string) {
  return studioImageMap[key.trim().toLowerCase()] ?? '';
}
